export default "__VITE_ASSET__0a481468__"